/* eslint-disable @typescript-eslint/naming-convention */
import type {
  InterstateOnChangeEvent,
  MenuItemEvent
} from "@dealer-center/core-components";
import { Button, MenuButton } from "@dealer-center/core-components";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AdvancedFiltersSelection from "./AdvancedFiltersSelection";
import { filters } from "../../utils/filters";
import type { SelectedFilterEntry } from "@dealer-center/ddc-pages-inventory-archiver-interface";
import {
  AdvancedFilterStyles,
  AdvancedFiltersWrapper
} from "./AdvancedFiltersStyles";

const AdvancedFiltersContainer = props => {
  const [selectedFilters, setSelectedFilters] = useState<SelectedFilterEntry[]>(
    []
  );
  const [searchParams, setSearchParams] = useSearchParams();

  const handleAddFilter = filter => {
    const exists = selectedFilters.some(f => f.name === filter.name);
    if (!exists) {
      setSelectedFilters([...selectedFilters, filter]);
    }
  };
  const handleRemoveFilter = (filterName: string) => {
    setSelectedFilters(filters =>
      filters.filter(item => item.name !== filterName)
    );
    searchParams.delete(filterName);
    setSearchParams(searchParams);
  };
  const handleSaveFilters = () => {
    selectedFilters.forEach(filter => {
      setSearchParams(
        prevParams => {
          prevParams.set(filter.name, filter.value);
          return prevParams;
        },
        { replace: true }
      );
    });
  };

  useEffect(() => {
    const paramFilters: SelectedFilterEntry[] = Array.from(
      searchParams.entries()
    )
      .filter(([key]) => filters[key.toUpperCase()])
      .map(([key, value]) => ({
        name: key.toUpperCase(),
        value
      }));

    setSelectedFilters(paramFilters);
  }, [searchParams]);

  return (
    <AdvancedFiltersWrapper>
      <MenuButton
        ButtonProps={{
          id: "account-selector"
        }}
        MenuProps={{
          id: "account-selector-menu",
          menuOptions: Object.entries(filters).map(([key, filter]) => ({
            onSelect: (event: InterstateOnChangeEvent<MenuItemEvent>) => {
              handleAddFilter(filter);
            },
            name: key,
            type: filter.type,
            label: filter.label
          }))
        }}
      >
        Add Filter
      </MenuButton>
      <AdvancedFiltersSelection
        filters={filters}
        handleRemoveFilter={handleRemoveFilter}
        selectedFilters={selectedFilters}
      />
      {selectedFilters?.length > 0 && (
        <Button
          analyticsConfiguration={{
            eventName: "Archiver Save Filters Clicked"
          }}
          onClick={handleSaveFilters}
        >
          Save
        </Button>
      )}
      <AdvancedFilterStyles />
    </AdvancedFiltersWrapper>
  );
};

export default AdvancedFiltersContainer;
